export default {
  educationalContent: 'Contenido educativo',
  createContent: 'Crear contenido'
}

export const en = {
  educationalContent: 'Educational content',
  createContent: 'Create content'
}

export const ca = {
  educationalContent: 'Contingut educatiu',
  createContent: 'Crear contingut'
}
